Vue.component('roomplanner2dLogin', {
    data() {
        return {
            root: this.$root

        };
    },
    mounted() {

    },
    watch: {
    },
    methods: {

        submitLogin(e) {
            this.submitForm(e.target);
        },
        submitForm(form) {

            if (form.checkValidity()) {

                if (form.querySelector('.g-recaptcha') !== null) {
                    grecaptcha.reset();
                    grecaptcha.execute();

                    return false;
                } else {
                    form.submit();
                    return true;
                }
            }

            return false;
        },

    },
});